import Vue from 'vue';
import { statHistoryCache } from 'tools/historycache';
import Translator from 'tools/trans';
import { pushToDataLayerOldFrontend } from 'search/dataLayer';

export default Vue.component('SearchHistory', {
    props: {
        userId: {
            type: String,
            required: true,
        },
        requestPath: {
            type: String,
            required: false,
            default: '/profile/searchhistorycontent/',
        },
        historyPath: {
            type: String,
            required: true,
        },

    },
    data() {
        return {
            historycache: statHistoryCache(),
        };
    },
    methods: {
        init() {
            this.historycache.getHistoryAjax(
                this.userId,
                'searchhistory',
                this.requestPath,
                '#searchHistoryListItem',
                'true',
                () => {
                    if (document.querySelector('[data-search-history-content]')) {
                        document.querySelector('#searchHistoryList').classList.remove('hide');
                    }
                }
            );
        },
        addToDataLayer() {
            // push to data layer
            setTimeout(() => {
                pushToDataLayerOldFrontend();
            });
        },
    },
    mounted() {
        this.init();
    },
    template: `
        <div id="searchHistoryList" ref="searchHistoryList" class="width100 padding-horizontal-30 padding-horizontal-s-0 margin-bottom-25 hideMobile hide">
            <h2 :onclick="addToDataLayer()" class="display-inline-block margin-right-20">
                <a id="searchHistoryElements" :href="historyPath" data-search-history-title-link class="text-semibold animated fadeInDown entity__headline margin-bottom-0 text-color--default">
                    ${ Translator.trans('SEARCH_HISTORY_LIST') }
                </a>
            </h2>
            <div id="searchHistoryListItem" class="display-inline-block">
            </div>
        </div>
    `,
});
